module.exports = __webpack_public_path__ + "img/misionvalores.9296de37.png";